let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6PY7Y")).then(() => parcelRequire('bqCcB'));